import { useState } from 'react';
import type { FaqItem } from '../content/methodology';

interface FaqAccordionProps {
  items: FaqItem[];
}

export function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIds, setOpenIds] = useState<Set<string>>(() => {
    const firstId = items[0]?.id;
    return firstId ? new Set([firstId]) : new Set();
  });

  return (
    <div className="faq-accordion" data-testid="faq-accordion">
      {items.map((item) => {
        const isOpen = openIds.has(item.id);
        const panelId = `faq-panel-${item.id}`;
        const buttonId = `faq-button-${item.id}`;

        return (
          <section className={`faq-accordion__item ${isOpen ? 'faq-accordion__item--open' : ''}`} key={item.id}>
            <h3 className="faq-accordion__heading">
              <button
                id={buttonId}
                className="faq-accordion__button"
                type="button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => {
                  setOpenIds((current) => {
                    const next = new Set(current);
                    if (next.has(item.id)) {
                      next.delete(item.id);
                    } else {
                      next.add(item.id);
                    }
                    return next;
                  });
                }}
              >
                <span>{item.question}</span>
                <span className="faq-accordion__icon" aria-hidden="true">
                  {isOpen ? '-' : '+'}
                </span>
              </button>
            </h3>
            <div
              id={panelId}
              className="faq-accordion__panel"
              role="region"
              aria-labelledby={buttonId}
              hidden={!isOpen}
            >
              {item.answer.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
